
export default function About() {
  return (
    <section id="about" className="py-16 md:py-24 bg-gradient-to-b from-white to-[#F5F5DC]">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center">
          <div>
            <div className="flex items-center gap-3 mb-4 md:mb-6">
              <i className="ri-seedling-line text-3xl md:text-4xl text-[#153223]"></i>
              <h2 className="font-['Yeseva_One',serif] text-3xl md:text-5xl text-[#153223]">
                About Us
              </h2>
            </div>
            <p className="text-base md:text-lg text-gray-700 mb-4 md:mb-6 leading-relaxed">
              <strong className="text-[#153223]">One Hill Tree (OHT) Tuition Academy</strong> specialises in structured English programs that develop reading fluency, vocabulary growth, and writing clarity.
            </p>
            <p className="text-base md:text-lg text-gray-700 mb-4 md:mb-6 leading-relaxed">
              Our home-based classes create a warm, focused environment, while our online classes offer flexibility for families across Malaysia and abroad.
            </p>
            <p className="text-base md:text-lg text-gray-700 leading-relaxed">
              We believe in <strong className="text-[#153223]">confidence, discipline, clarity, and steady progress</strong> — one step at a time.
            </p>
          </div>

          <div className="relative">
            <img 
              src="https://public.readdy.ai/ai/img_res/fb8a3c8a1b86cf84715e917533a414e8.jpg"
              alt="OHT Home-Based Learning Environment"
              className="rounded-2xl shadow-2xl w-full h-[300px] md:h-[500px] object-cover object-top"
            />
            <div className="absolute -bottom-4 -left-4 md:-bottom-6 md:-left-6 bg-[#153223] p-4 md:p-6 rounded-xl shadow-xl">
              <p className="text-[#FFE66D] font-bold text-base md:text-xl">Home-Based Learning</p>
              <p className="text-white text-xs md:text-sm">Warm & Focused Learning</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
